import * as actionTypes from "./actionTypes";

export const getNews = (day: number, newsType: string) => ({
  type: actionTypes.GET_NEWS,
  day,
  newsType
});

export const moveCalendar = (
  newsType: string,
  year: number,
  month: number,
  direction: string
) => ({
  type: actionTypes.MOVE_CALENDAR,
  newsType,
  year,
  month,
  direction
});

export const updateNews = (newsUpdate: any) => ({
  type: actionTypes.UPDATE_NEWS,
  newsUpdate
});
